import { Link } from 'react-router-dom';
import { featuredBrands } from '@/mocks/home';

export default function RecommendedBrands() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" id="brands" aria-labelledby="brands-title">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 id="brands-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            推荐品牌
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            精选国内顶尖品牌，品质值得信赖
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredBrands.map((brand) => (
            <div
              key={brand.id}
              className="bg-background-50 rounded-lg p-5 flex flex-col items-center text-center transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-20 h-20 rounded-full overflow-hidden mb-4">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <span className="inline-block bg-secondary-100 text-secondary-700 text-xs px-3 py-1 rounded-full mb-2 capitalize">
                {brand.category}
              </span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900">{brand.name}</h3>
              <div className="flex items-center gap-1 mt-1 mb-3">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-medium text-foreground-700">{brand.rating}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{brand.description}</p>
              <Link
                to={`/category?tab=${brand.category === '国产美妆' ? 'meizhuang' : brand.category === '国产数码' ? 'shuma' : brand.category === '国产食品' ? 'shipin' : 'fushi'}`}
                className="mt-4 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                查看相关推荐 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}